import { render, staticRenderFns } from "./ActiveOffers.vue?vue&type=template&id=6ca4644f&"
import script from "./ActiveOffers.vue?vue&type=script&lang=js&"
export * from "./ActiveOffers.vue?vue&type=script&lang=js&"
import style0 from "./ActiveOffers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports